import { jsx as i, jsxs as r } from "react/jsx-runtime";
import { CurrencyBadge as m } from "../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as _ } from "../../utils/get-amount-with-currency-symbol.mjs";
import { centsToUnits as d, useTranslation as f } from "@systemeio/ui";
import { PricePlanTypeEnum as p } from "../../libs/types/dist/index9.mjs";
import { Trans as h } from "react-i18next";
import { useLocaleContext as u } from "../../providers/use-locale-provider.mjs";
const b = ({ children: l }) => /* @__PURE__ */ i("span", { className: "font-semibold", children: l }), T = ({ type: l, amount: t, currency: e, recurringOptions: o }) => {
  if (l === p.one_shot)
    return /* @__PURE__ */ i(v, { amount: t, currency: e });
  if (l === p.subscription)
    return /* @__PURE__ */ i(
      P,
      {
        amount: t,
        currency: e,
        recurringOptions: o
      }
    );
  if (l === p.limited_subscription)
    return /* @__PURE__ */ i(
      x,
      {
        amount: t,
        currency: e,
        recurringOptions: o
      }
    );
}, v = ({
  amount: l,
  currency: t
}) => {
  const { locale: e } = u(), o = _(
    d(l),
    t,
    e
  );
  return /* @__PURE__ */ r("div", { className: "flex items-center", children: [
    /* @__PURE__ */ i(m, { currency: t }),
    /* @__PURE__ */ i("div", { className: "ml-1 text-[14px] font-semibold", children: o })
  ] });
}, P = ({
  amount: l,
  currency: t,
  recurringOptions: e
}) => {
  const { locale: o } = u(), { t: a } = f(), s = _(
    d(l),
    t,
    o
  ), n = e.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${e.trialInterval}`,
      {
        count: e.trialPeriod
      }
    )
  })} ` : void 0, c = /* @__PURE__ */ i(
    h,
    {
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.unlimited_new",
      values: {
        amount: s,
        interval: a(`public_pages_purchase.price_plan.interval.${e.interval}`, {
          count: e.intervalCount
        })
      },
      components: {
        bold: /* @__PURE__ */ i(b, {})
      }
    }
  );
  return /* @__PURE__ */ r("div", { className: "flex items-center", children: [
    /* @__PURE__ */ i(m, { currency: t }),
    /* @__PURE__ */ r("div", { className: "ml-3", children: [
      n && /* @__PURE__ */ i("div", { className: "text-[14px] font-semibold", children: n }),
      /* @__PURE__ */ i("div", { className: "text-[14px]", children: c })
    ] })
  ] });
}, x = ({
  amount: l,
  currency: t,
  recurringOptions: e
}) => {
  const { locale: o } = u(), { t: a } = f(), s = _(
    d(l),
    t,
    o
  ), n = e.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${e.trialInterval}`,
      {
        count: e.trialPeriod
      }
    )
  })} ` : void 0, c = /* @__PURE__ */ i(
    h,
    {
      t: a,
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.limited_with_limit_of_payments",
      values: {
        amount: s,
        count: e.limitOfPayments,
        interval: a(`public_pages_purchase.price_plan.interval.${e.interval}`, {
          count: e.intervalCount
        })
      }
    }
  );
  return /* @__PURE__ */ r("div", { className: "flex items-center", children: [
    /* @__PURE__ */ i(m, { currency: t }),
    /* @__PURE__ */ r("div", { className: "ml-3", children: [
      n && /* @__PURE__ */ i("div", { className: "text-[14px] font-semibold", children: n }),
      /* @__PURE__ */ i("div", { className: "text-[14px] font-semibold", children: c })
    ] })
  ] });
};
export {
  x as PricePlanLimitedSubscriptionInfo,
  v as PricePlanOneShotInfo,
  P as PricePlanSubscriptionInfo,
  T as default
};
